export default __webpack_public_path__ + "static/lars_deckruede-46b1ccdd620cf1c8181e9d00a1d463f4.jpg";